import { computed } from 'vue';

import tt from '@/i18n/utils/translateText';
import {
  EExecutorsLookupAutoPublishType,
  EAcceptanceMethod,
  EContractType,
  EPartnershipResourcesDocumentStatusType,
  EPartnershipResourceStatus,
  EPartnershipType,
  EContractsTableStatus,
} from '@partnershipsContext/domain/constants';
import { TStatusChangerCurrentState } from '@/ui/experimental/StatusChanger/domain/types';
import { EStatusType } from '@/domains/constants';

export const useView = () => {
  const CONTRACTS_TABLE_STATUS_TRANSLATION = computed(() => ({
    [EContractsTableStatus.active]: tt('partnerships.contracts.status.active'),
    [EContractsTableStatus.inactive]: tt('partnerships.contracts.status.inactive'),
    [EContractsTableStatus.archived]: tt('shared.archive'),
  }));

  const PARTNERSHIP_TYPE = computed(() => ({
    [EPartnershipType.client]: tt('shared.asCustomer'),
    [EPartnershipType.servicer]: tt('shared.asExecutor'),
  }));

  const CONTRACT_TYPE_NAMES = computed(() => ({
    [EContractType.transportationContract]: tt('shared.transportationContract'),
    [EContractType.transportExpeditionContract]: tt('shared.transportExpeditionContract'),
  }));

  const ACCEPTANCE_METHOD_OPTIONS = computed(() => [
    {
      value: EAcceptanceMethod.auto,
      label: tt('partnerships.list.acceptanceMethod.auto'),
    },
    {
      value: EAcceptanceMethod.manual,
      label: tt('partnerships.list.acceptanceMethod.manual'),
    },
  ]);

  const ACCEPTANCE_METHOD = computed(() => ({
    [EAcceptanceMethod.auto]: tt('partnerships.list.acceptanceMethod.auto'),
    [EAcceptanceMethod.manual]: tt('partnerships.list.acceptanceMethod.manual'),
  }));

  const EXECUTORS_LOOKUP_AUTOPUBLISH_OPTIONS = computed(() => [
    {
      value: EExecutorsLookupAutoPublishType.reduction,
      label: tt('partnerships.list.executorsLookupAutoPublish.reduction'),
    },
    {
      value: EExecutorsLookupAutoPublishType.freeOffering,
      label: tt('partnerships.list.executorsLookupAutoPublish.freeOffering'),
    },
    {
      value: EExecutorsLookupAutoPublishType.disabled,
      label: tt('partnerships.list.reductionAutoPublish.manual'),
    },
  ]);

  const PARTNERSHIP_RESOURCE_SERVICER_STATUS_TRANSLATION = computed(() => ({
    [EPartnershipResourceStatus.verified]: tt('partnerships.shared.servicerStatuses.verified'),
    [EPartnershipResourceStatus.paused]: tt('partnerships.shared.servicerStatuses.paused'),
  }));

  const PARTNERSHIP_RESOURCE_CLIENT_STATUS_TRANSLATION = computed(() => ({
    [EPartnershipResourceStatus.verified]: tt('shared.checked'),
    [EPartnershipResourceStatus.rejected]: tt('partnerships.shared.clientStatuses.rejected'),
    [EPartnershipResourceStatus.unverified]: tt('shared.notChecked'),
    [EPartnershipResourceStatus.awaitingVerification]: tt('shared.awaitingVerification'),
    [EPartnershipResourceStatus.verification]: tt('shared.verification'),
  }));

  const PARTNERSHIP_RESOURCES_DOCUMENTS_STATUS_MODEL = computed<TStatusChangerCurrentState[]>(() => [
    {
      slug: EPartnershipResourcesDocumentStatusType.unverified,
      title: tt('partnershipResources.view.documents.statusModel.unverified'),
      type: EStatusType.default,
    },
    {
      slug: EPartnershipResourcesDocumentStatusType.verified,
      title: tt('partnershipResources.view.documents.statusModel.verified'),
      type: EStatusType.success,
    },
    {
      slug: EPartnershipResourcesDocumentStatusType.adjustmentRequired,
      title: tt('partnershipResources.view.documents.statusModel.adjustmentRequired'),
      type: EStatusType.warning,
    },
  ]);

  return {
    CONTRACTS_TABLE_STATUS_TRANSLATION,
    PARTNERSHIP_TYPE,
    CONTRACT_TYPE_NAMES,
    ACCEPTANCE_METHOD,
    ACCEPTANCE_METHOD_OPTIONS,
    EXECUTORS_LOOKUP_AUTOPUBLISH_OPTIONS,
    PARTNERSHIP_RESOURCE_CLIENT_STATUS_TRANSLATION,
    PARTNERSHIP_RESOURCE_SERVICER_STATUS_TRANSLATION,
    PARTNERSHIP_RESOURCES_DOCUMENTS_STATUS_MODEL,
  };
};
